import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../../containers/Layout/Layout";
import {
  loadLocationsAction,
  saveLocationAction,
  addLocationAction,
  getLocations,
  isLoading,
  isSaving
} from "../../../state/data";
import Loader from "../../atomic/Loader/Loader";
import { Link } from "react-router-dom";
import LocationsTable from "../../partials/LocationsTable/LocationsTable";
import Panel from "../../atomic/Panel/Panel";
import FloatingButton from "../../atomic/FloatingButton/FloatingButton";

export function generateId() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const LocationsPage = ({}) => {
  const locations = useSelector(getLocations);
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);
  const saving = useSelector(isSaving);
  const newLocId = generateId();
  useEffect(() => {
    if (!locations) {
      dispatch(loadLocationsAction());
    }
  }, []);
  if (!locations || loading) {
    return <Loader />;
  }
  return (
    <Layout>
      <h1>Locations</h1>
      <Panel>
        <LocationsTable locations={locations} />
      </Panel>
      <FloatingButton
        link={"/location/" + newLocId}
        icon="plus"
      ></FloatingButton>
    </Layout>
  );
};

export default LocationsPage;
